/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 9,
    height: 12,
    viewBox: '0 0 9 12',
    data: '<path pid="0" d="M6.5 3a2 2 0 11-4 0 2 2 0 014 0zm-2 4.5c1.673 0 2.63.421 3.187 1.055.494.562.744 1.373.8 2.445H.513c.056-1.072.306-1.883.8-2.445C1.87 7.92 2.827 7.5 4.5 7.5z" _fill="#0071B3" _stroke="#0071B3"/>'
  }
})
